import React, { useState, useEffect } from 'react';

import { Box, Container } from '@mui/material';

// Components
import Header from '../Header';
import LeftSideBar from '../LeftSidebar';

// Images
import bgImage from '../../assets/images/bg-img.png';
import godModeBgImage from '../../assets/images/god-mode.png';

import ScrollArea from 'react-scrollbar';
import { useTheme, } from '../../hooks';

import styles from './style.module.css';

const Layout = ({ children }) => {
  const { theme } = useTheme();
  const [toggleSidebar, setToggleSidebar] = useState(true)
  useEffect(() => {
    // setTimeout(() => {
    //   setToggleSidebar(false)
    // }, 1500);
    setToggleSidebar(false)
  }, []);
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        backgroundImage: `url(${theme === 'dark' ? bgImage : godModeBgImage})`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        overflowY: 'hidden',
      }}
    >
      <LeftSideBar toggleSidebar={toggleSidebar} setToggleSidebar={setToggleSidebar} />
      <Box className={styles.mainWrap}>
        <Container className='main_content_wrap'>
          <Header />
        </Container>
        <Box height={'90vh'}>
          <ScrollArea speed={0.8} contentClassName="content" horizontal={false} style={{ height: '100%' }}>
            <Box marginBottom={4}>
              <Container className='main_content_wrap'>{children}</Container>
            </Box>
          </ScrollArea>
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
